import styled from '@emotion/styled';
import { AppColors } from '#lib/constants';

export const StyledSeparator = styled.div({
  borderBottom: `1px solid ${AppColors.MERCURY}`,
  marginTop: '8px',
});
